let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1VEoh")).then(() => parcelRequire('2e4bZ'));